// extracted by mini-css-extract-plugin
export default {"myPopUp":"popUp_myPopUp__Qogr-","active":"popUp_active__VAS65"};